"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgCircleWhite = props => (0, jsx_runtime_1.jsx)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 6
}, props, {
  children: (0, jsx_runtime_1.jsx)("circle", {
    "data-name": "Ellipse 29",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#fcfdff"
  }, void 0)
}), void 0);

exports.default = SvgCircleWhite;